module.exports = __webpack_public_path__ + "static/media/oblong_a.69a452f4.svg";